import { defineMessages } from "react-intl";
import { validator } from "lib/build/forms/ltx/phase-i/lab-procedures/autoimmun-lab-procedures/antiCardiolipinAt";
import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	antiCardiolipinAt: {
		id: "form.anti_cardiolipin_at",
		defaultMessage: "Anti-cardiolipin AT"
	},
	igG: {
		id: "form.anti_cardiolipin_at.igg",
		defaultMessage: "IgG"
	},
	igM: {
		id: "form.anti_cardiolipin_at.igm",
		defaultMessage: "IgM"
	},
	igA: {
		id: "form.anti_cardiolipin_at.iga",
		defaultMessage: "IgA"
	}
});

const fields: { [key: string]: FieldData } = {
	igG: {
		type: "field",
		path: ["IgG"],
		label: messages.igG,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	igM: {
		type: "field",
		path: ["IgM"],
		label: messages.igM,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	igA: {
		type: "field",
		path: ["IgA"],
		label: messages.igA,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.igG }] },
		{ columns: [{ width: 12, field: fields.igM }] },
		{ columns: [{ width: 12, field: fields.igA }] }
	]
};

export const node: LeafNode = {
	id: "antiCardiolipinAt",
	value: {
		title: messages.antiCardiolipinAt,
		validator,
		fieldset,
		isImportant: true
	}
};
